class PdpDeliveryCountdown {
  constructor(container) {
    this.container = container;
    this.timeEl = container.querySelector('[data-countdown-time]');

    const cutoffHour = parseInt(container.getAttribute('data-cutoff-hour') || '14', 10);
    const cutoffMinute = parseInt(container.getAttribute('data-cutoff-minute') || '0', 10);

    this.cutoffHour = Number.isFinite(cutoffHour) ? cutoffHour : 14;
    this.cutoffMinute = Number.isFinite(cutoffMinute) ? cutoffMinute : 0;

    this.interval = null;

    this.tick = this.tick.bind(this);
    this.start();
  }

  getNextCutoff(now) {
    const cutoff = new Date(now);
    cutoff.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);

    if (cutoff.getTime() <= now.getTime()) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    return cutoff;
  }

  format(hours, minutes, seconds) {
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');
    return `${hh}h ${mm}m ${ss}s`;
  }

  tick() {
    if (!this.timeEl) return;

    const now = new Date();
    const cutoff = this.getNextCutoff(now);
    const diffMs = Math.max(0, cutoff.getTime() - now.getTime());

    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.timeEl.textContent = this.format(hours, minutes, seconds);
  }

  start() {
    this.tick();
    if (this.interval) window.clearInterval(this.interval);
    this.interval = window.setInterval(this.tick, 1000);
  }
}

function initPdpDeliveryCountdown() {
  document.querySelectorAll('[data-delivery-countdown]').forEach((el) => {
    if (el.__pdpDeliveryCountdown) return;
    el.__pdpDeliveryCountdown = new PdpDeliveryCountdown(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpDeliveryCountdown);
} else {
  initPdpDeliveryCountdown();
}
